export default "__VITE_ASSET__b018037b__"